export default {
  errorsRootKey: 'webhooks',
  resource: 'calltrackings/webhooks',
  actions: ['index']
}
